/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizercover1Inputs */

const en_organizercover1 = /** @type {(inputs: Organizercover1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change cover`)
};

const de_organizercover1 = /** @type {(inputs: Organizercover1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild ändern`)
};

/**
* | output |
* | --- |
* | "Change cover" |
*
* @param {Organizercover1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizercover1 = /** @type {((inputs?: Organizercover1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizercover1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizercover1(inputs)
	return de_organizercover1(inputs)
});
export { organizercover1 as "organizerCover" }